// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T16:38:38.192Z
// Property: Passage (ID: 6767906449166807)
// Collections: 27 amenities, 3 floorplans (live), 39 photos, 29 POIs, 9 reviews, 3 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166807",
  "property_external_id": "180PSG",
  "property_zillow_url": "https://www.zillow.com/apartments/vancouver-wa/passage/5XjT9Y/",
  "property_apartments_url": "https://www.apartments.com/passage-vancouver-wa/9n68hy5/",
  "property_google_business_url": "https://www.google.com/maps/place/Passage+Apartments/data=!4m2!3m1!1s0x0:0x6c30de9d4ddda?sa=X&ved=2ahUKEwjr3_eM6KeSAxVlZfUHHdSFGhsQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "41611142705",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "180PSG",
  "property_status": null,
  "property_slug": "passage",
  "property_name": "Passage",
  "property_website_url": "https://www.liveatpassage.com/",
  "property_domain": "https://www.liveatpassage.com/",
  "property_address": "12800 Southeast 7th Street",
  "property_full_address": "12800 SE 7th St, Vancouver, WA 98683",
  "property_address_1": "12800 SE 7th St",
  "property_address_2": null,
  "property_address_city": "Vancouver",
  "property_address_state": "WA",
  "property_address_zip_full": "98683",
  "property_address_zip": "98683",
  "property_address_country": "US",
  "property_address_county": "Clark County",
  "property_neighborhood_address": "Cascade Park",
  "property_address_latitude": "45.6168236",
  "property_address_longitude": "-122.5414998",
  "property_email": "psgmgr@amcllc.net",
  "property_phone": "(360) 256-7200",
  "property_call_tracking_phone": "855-384-0673",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Passage, where vibrant living meets comfort in Vancouver, WA. Choose from spacious two- and three-bedroom layouts, complete with modern amenities like a refreshing pool, cozy fireplace, and energizing fitness center. Experience the perfect blend of leisure and convenience—schedule your tour or browse availability to find your new home today!",
  "property_long_description": "Welcome to Passage, your ideal retreat located in the heart of Vancouver, WA! Our thoughtfully designed two and three-bedroom apartment floor plans cater to your lifestyle needs, offering spacious living with modern conveniences. Every home features luxurious amenities such as walk-in closets, a fully-equipped kitchen with a microwave, dishwasher, and refrigerator, along with a cozy fireplace perfect for those chillier evenings.\n\nAt Passage, we prioritize your comfort and leisure. Enjoy sunny days lounging by our sparkling pool, or unwind in the hot tub and spa after a vigorous workout in our state-of-the-art fitness center. For families, our playground and gameroom provide endless entertainment, while our multi-use room and clubhouse are perfect for hosting gatherings with friends and family. \n\nOur community is designed for convenience—benefit from door-to-door trash pickup, on-site maintenance, and a dedicated property manager always available to assist you. Plus, with high-speed internet access and Wi-Fi throughout the property, you can stay connected effortlessly.\n\nYour furry friends are welcome here too, with a dedicated dog park for their enjoyment. And when it’s time to relax, take a stroll through our beautifully landscaped courtyard or host a barbecue on the sundeck. With essential features like washer/dryer units, heating, and wheelchair accessibility, we ensure your living experience is both comfortable and accommodating.\n\nDon’t wait to make Passage your new home! Browse our availability or schedule a tour today and discover the vibrant lifestyle waiting for you in our community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-855f-771d-a3dd-e88c55520a8b.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas in a residential complex.",
    "public_id": "019f3955-855f-771d-a3dd-e88c55520a8b",
    "storage_key": "property/6767906449166807/019f3955-855f-771d-a3dd-e88c55520a8b.webp",
    "width": 3072,
    "height": 2049
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "104",
  "property_year_built": "1991",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.26923076923077",
  "property_admin_fee": "300",
  "property_application_fee": "65",
  "property_fees_deposit_info": "500-1 Month's Rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "35",
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "Please contact our Leasing Office for our pet policy.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://www.myrentalapplication.com/index/amcpassage",
  "property_resident_portal_url": "http://passage.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcpassage",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d20b8-6f22-752d-b4a9-8777e2e06329.webp",
  "property_primary_logo_media": {
    "alt_text": "Passage Apartments logo",
    "public_id": "019d20b8-6f22-752d-b4a9-8777e2e06329",
    "storage_key": "property/6767906449166807/019d20b8-6f22-752d-b4a9-8777e2e06329.webp",
    "width": 459,
    "height": 150
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d20b8-836e-70c8-a0cf-89a4ece84a91.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Passage Apartments logo",
    "public_id": "019d20b8-836e-70c8-a0cf-89a4ece84a91",
    "storage_key": "property/6767906449166807/019d20b8-836e-70c8-a0cf-89a4ece84a91.webp",
    "width": 459,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d20b8-8cd7-737e-86e9-577b62972c20.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Passage Apartments logo",
    "public_id": "019d20b8-8cd7-737e-86e9-577b62972c20",
    "storage_key": "property/6767906449166807/019d20b8-8cd7-737e-86e9-577b62972c20.webp",
    "width": 459,
    "height": 150
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#111111",
  "property_secondary_color": "#1ECBE1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "892 - 9,751,020 sq ft",
  "property_sqft_min": "892",
  "property_sqft_max": "1216",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": "2215",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/PassageApartment",
  "property_instagram_url": "https://www.instagram.com/passageapartmentswa/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJUzMi8R6llVQR2t3U6Q3DBgA",
  "property_youtube_url": "https://www.youtube.com/watch?t=103&v=Ak6C6HhvZe8",
  "property_yelp_url": "https://www.yelp.com/biz/passage-vancouver",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Passage",
  "property_home_romance_title": "Embrace a New Love in Your Perfect Apartment Oasis",
  "property_home_amenities_blurb": "Welcome to Passage, your vibrant sanctuary in Vancouver, WA! Choose from spacious two or three-bedroom floor plans, each designed for comfort. Enjoy exclusive amenities like a shimmering pool, invigorating fitness center, and a cozy clubhouse, all while embracing a lifestyle enriched by community and convenience. Your perfect home awaits!",
  "property_home_floorplans_blurb": "At Passage in Vancouver, WA, your ideal living space awaits. With an array of thoughtfully designed floor plans, you’ll find the perfect apartment to match your lifestyle. Experience the blend of comfort and modern aesthetics—browse our available homes today and step into your new sanctuary!",
  "property_home_gallery_blurb": "At Passage in Vancouver, WA, every detail is designed for your comfort. Choose from spacious two- or three-bedroom floor plans while enjoying amenities like a refreshing pool, invigorating fitness center, and a vibrant dog park. Picture yourself relaxing on the sundeck or gathering with friends in the clubhouse!",
  "property_home_neighborhood_blurb": "Welcome to Passage, your ideal sanctuary in Vancouver, WA! Choose from spacious two- and three-bedroom floor plans while enjoying vibrant local treasures. From the historic Pearson Air Museum to beautiful parks like Fernhill and Wintler, there’s adventure at every turn. Embrace comfort and community—your new home awaits!",
  "property_home_reviews_blurb": "At Passage in Vancouver, WA, residents rave about their vibrant community, highlighting it as “a gem with friendly neighbors and beautiful spaces.” Experience comfort and camaraderie in a setting designed for your lifestyle. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Passage in Vancouver, WA, vibrant living flourishes among an array of attractions. From the lush landscapes of Rocky Butte Natural Area to the historical charm of Pearson Air Museum, our neighborhood bursts with excitement. Unwind at Fernhill Park or boost your energy at 24 Hour Fitness, all just moments away!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Passage in Vancouver, WA, enjoy spacious two and three-bedroom apartments paired with extraordinary amenities. Lounge by the pool, challenge friends in the gameroom, or relax in the hot tub. With a dog park, clubhouse, and even on-site maintenance, your perfect lifestyle awaits. Embrace comfort and convenience today!",
  "property_applynow_blurb": "At Passage in Vancouver, WA, modern living meets exceptional amenities. Choose from spacious two and three-bedroom floor plans featuring walk-in closets and cozy fireplaces. Enjoy our inviting pool, vibrant clubhouse, and dog park. Let our dedicated team simplify your life—apply online today and step into your new home!",
  "property_contactus_blurb": "At Passage in Vancouver, WA, our thoughtfully designed two and three-bedroom floor plans offer the perfect blend of comfort and style. Experience spacious living with modern amenities tailored to your lifestyle. Have questions? Contact our leasing team today and let us help you find your ideal home!",
  "property_faqs_blurb": "At Passage in Vancouver, WA, our thoughtfully designed two and three-bedroom floor plans cater to every lifestyle. Elevate your living experience with spacious layouts and modern amenities. Have questions? Our FAQs page is your go-to resource for insights about our vibrant community. Dive into answers today!",
  "property_floorplans_blurb": "At Passage in Vancouver, WA, our thoughtfully designed two and three-bedroom floor plans cater to your unique lifestyle. Embrace spacious living with modern amenities and inviting layouts. Ready to elevate your home experience? Browse our available apartment homes and uncover the perfect floor plan that meets your needs.",
  "property_gallery_blurb": "At Passage in vibrant Vancouver, WA, envision a life filled with comfort and convenience. With spacious two- and three-bedroom floor plans, enjoy amenities like a refreshing pool, a state-of-the-art fitness center, and a welcoming dog park. Your future home awaits—picture yourself living here and immerse in the lifestyle you deserve!",
  "property_interactivemap_blurb": "At Passage in Vancouver, WA, elevate your lifestyle with spacious two and three-bedroom apartments featuring modern amenities like high-speed internet, a refreshing pool, and a vibrant dog park. Utilize our interactive community map to uncover your perfect home today—embrace comfort and convenience just a click away!",
  "property_pets_blurb": "At Passage in Vancouver, WA, your ideal living experience awaits. Nestled amid vibrant surroundings, our thoughtfully designed apartments blend luxury with comfort. Enhance your lifestyle with pet-friendly options—connect with our Leasing Office for details. Live where convenience meets community and enjoy everything we have to offer!",
  "property_referafriend_blurb": "At Passage in Vancouver, WA, our inviting two and three-bedroom apartments offer the perfect setting for creating cherished memories. Great friends make great neighbors—refer a friend today and enjoy living in a vibrant community where connections thrive and every moment feels like home. ",
  "property_residentaccess_blurb": "At Passage in Vancouver, WA, our thoughtfully designed two and three-bedroom floor plans cater to your lifestyle needs. Seamlessly manage your home with easy access to our resident portal—pay rent, schedule maintenance, and enjoy hassle-free living. Join us and elevate your apartment experience today!",
  "property_reviews_blurb": "At Passage in Vancouver, WA, residents rave about their \"serene environment and friendly neighbors,\" making it a true community gem. Immerse yourself in the vibrant lifestyle that Passage offers. See what our residents have to say about living at our community!",
  "property_created_at": "1762201418193",
  "property_scheduletour_blurb": "At Passage in Vancouver, WA, spacious two and three-bedroom apartments invite you to experience comfort and style. Picture your ideal living space with diverse floor plans that cater to your lifestyle. Schedule a tour today and check out our resident testimonials to see why they love calling Passage home!",
  "property_thankyou_blurb": "Thank you for reaching out to Passage, where modern living meets comfort in Vancouver, WA. With our spacious two and three-bedroom floor plans, you'll find the perfect space to call home. Keep an eye on your inbox; a team member will connect soon to assist you further!",
  "property_virtualtours_blurb": "Experience contemporary living at Passage in Vancouver, WA. Our thoughtfully designed two and three-bedroom apartments cater to diverse lifestyles. With spacious layouts and modern amenities, you’ll find your perfect home. Take a virtual tour today to envision your future in our welcoming community!",
  "property_copyright": "2025 All Rights Reserved. Passage",
  "property_seo_title_home": "Vancouver, WA Apartments for Rent | Passage | Home",
  "property_seo_description_home": "Discover Passage Apartments in Vancouver, WA, offering 2- and 3-bedroom apartments with community amenities and easy access to shopping and dining.",
  "property_seo_title_floorplans": "Vancouver, WA Apartments | Passage Apartments | Floor Plans",
  "property_seo_description_floorplans": "Explore two- and three-bedroom floor plans at Passage Apartments in Vancouver, WA, featuring open layouts, washers and dryers, and private patios or balconies.",
  "property_seo_title_amenities": "Vancouver, WA Rentals | Passage Apartments | Amenities",
  "property_seo_description_amenities": "View the amenities at Passage Apartments in Vancouver, WA, including a fitness center, swimming pool, clubhouse, playground, sundeck, garage parking, and more.",
  "property_seo_title_gallery": "Two-bedroom Apartments in Vancouver, WA | Gallery",
  "property_seo_description_gallery": "Browse the gallery of Passage Apartments in Vancouver, WA, and see apartment interiors, community amenities, outdoor spaces, and more before your visit.",
  "property_seo_title_virtualtours": "Two-bedroom Rentals in Vancouver, WA | Virtual Tour",
  "property_seo_description_virtualtours": "Take a virtual tour of Passage Apartments in Vancouver, WA, and explore apartment interiors, community amenities, and shared spaces from anywhere.",
  "property_seo_title_interactivemap": "Three-bedroom Rentals in Vancouver, WA | Interactive Leasing",
  "property_seo_description_interactivemap": "Use the interactive leasing experience at Passage Apartments in Vancouver, WA, to explore floor plans, availability, and begin your leasing journey online.",
  "property_seo_title_neighborhood": "Three-bedroom Apartments in Vancouver, WA | Neighborhood",
  "property_seo_description_neighborhood": "Learn about the neighborhood surrounding Passage Apartments in Vancouver, WA, near Downtown Vancouver, Vancouver Mall, and Columbia Square.",
  "property_seo_title_contact": "Downtown Vancouver, WA Apartments for Rent | Contact",
  "property_seo_description_contact": "Contact the team at Passage Apartments in Vancouver, WA, for information about availability, floor plans, leasing, or to schedule your visit.",
  "property_seo_title_faqs": "FAQs | Apartments in Vancouver, WA",
  "property_seo_description_faqs": "Get the answers you need about Passage in Vancouver, WA! From amenities to floor plans, browse our FAQs and discover your ideal apartment home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Vancouver, WA",
  "property_seo_description_reviews": "At Passage in Vancouver, WA, our residents thrive! Dive into their stories and see why our community, featuring luxurious amenities, feels like home.",
  "property_seo_title_applynow": "Apartments with a Pool in Vancouver, WA | Apply",
  "property_seo_description_applynow": "Apply online for an apartment at Passage Apartments in Vancouver, WA. Complete your application securely and take the next step toward your new home.",
  "property_seo_title_residentaccess": "Apartments with Garages in Vancouver, WA | Resident Access",
  "property_seo_description_residentaccess": "Access the resident portal for Passage Apartments in Vancouver, WA, to make payments, submit maintenance requests, and manage your account online.",
  "property_seo_title_referafriend": "Refer A Friend | Passage",
  "property_seo_description_referafriend": "Refer a friend to Passage in Vancouver, WA! Enjoy great living, fantastic amenities, and a vibrant community. Let's build a neighborhood together!",
  "property_seo_title_scheduletour": "Apartments Near Downtown Vancouver, WA | Tour",
  "property_seo_description_scheduletour": "Schedule a tour of Passage Apartments in Vancouver, WA, and explore available two- and three-bedroom apartments, community amenities, and the neighborhood.",
  "property_seo_title_privacy": "Privacy Policy | Passage",
  "property_seo_description_privacy": "Experience peace of mind at Passage in Vancouver, WA. Your privacy matters—learn how we safeguard your information. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Passage",
  "property_seo_description_accessibility": "Join Passage in Vancouver, WA for seamless accessibility and a welcoming community that prioritizes digital inclusion for everyone!",
  "property_seo_title_sitemap": "Sitemap | Passage",
  "property_seo_description_sitemap": "Navigate your way to your perfect home at Passage in Vancouver, WA. Check out our sitemap for amenities, layouts, and more that await you!",
  "property_seo_title_thankyou": "Rentals in Vancouver, WA | Passage Apartments | Thank You",
  "property_seo_description_thankyou": "Thank you for contacting Passage Apartments in Vancouver, WA. A member of our leasing team will be in touch with you soon.",
  "property_seo_title_pets": "Pet-friendly Rentals in Vancouver, WA | Pet Policy",
  "property_seo_description_pets": "Learn about the pet policy at Passage Apartments in Vancouver, WA, including community guidelines and information for residents with pets.",
  "property_updated_at": "1791293624356",
  "amenities": [
    {
      "id": "custom_9480786a-5b59-4fd8-89b3-cb1096787c54",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76b18270-48b6-47e7-b648-e73635b79e7d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_84d60cea-f5c7-4123-bdf3-d94ae44a6e74",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Garages",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_54d571c0-e0ab-4eb5-83f8-d45fcc13d63f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4fa6f5d5-fb66-4837-a3e3-26065c73f251",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1c5ce501-fe7e-47d7-a232-1a50ef4e3495",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e1c6c0aa-a88e-4840-a402-0ab862963533",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6db6e00f-68a2-4c08-a517-8174431e20cd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Additional Storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e389bd3-15ac-4ff7-9c18-4f6e474cca5d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dfccfd74-46b5-4f70-936e-3349339b6de0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio / Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d0579ef4-8ef1-49a0-8881-e7d5b9d80013",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ca05b096-2156-45ae-a680-c3cd1bfdd649",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f943ab87-a228-4df2-86ec-5e304ba96241",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Wheelchair Accessible*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e9ebab4a-45ae-4edd-80d2-a35e8ce44246",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_db464337-8c0b-4f14-868b-4d48ffddc80a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5ecc7b71-dd2f-43f2-a08c-fb9158aec4f2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76c9bde6-5728-4ef4-914c-db549ba31441",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_741e2c6c-d1b6-49a4-b2bb-3d8685be2896",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_65edaec5-11dc-4409-94ca-c97d61de878d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e23b0090-91ed-4502-8a98-604e3f28767a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ grill",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9a6f48f0-d1ea-4ece-9608-1e85fb3c2ce0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8be08581-96d5-4ca3-bc64-69941b62294c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Pre-installed High-Speed Internet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b12125a5-c57b-4ef6-8474-d5d20aca7523",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2260fc0d-794b-4c43-adcb-b9935fc8b1c9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_58672fe0-c428-4de5-8219-648346912da3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Gameroom",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af281584-6b4b-4318-ab2d-0dc44588fddf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1be9b2ca-a9cd-4458-afc3-64cc8fbbdb1a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "external_id": "false",
      "title": "Secure Package Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_9c447006-6dc7-4f52-aec5-3cf679a3dd38",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-855f-771d-a3dd-e88c55520a8b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas in a residential complex.",
        "public_id": "019f3955-855f-771d-a3dd-e88c55520a8b",
        "storage_key": "property/6767906449166807/019f3955-855f-771d-a3dd-e88c55520a8b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and refreshing umbrellas. A perfect oasis for residents.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas in a residential complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a1539711-c60b-4f9f-a1d0-634a6fe36f55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-8269-721c-96f7-47756f8dc6f8.webp",
      "image_media": {
        "alt_text": "Passage Apartments monument sign",
        "public_id": "019f3955-8269-721c-96f7-47756f8dc6f8",
        "storage_key": "property/6767906449166807/019f3955-8269-721c-96f7-47756f8dc6f8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to Passage Apartments, featuring a prominent monument sign at the entrance to the community.",
      "link": "",
      "alt_text": "Passage Apartments monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d7d617ac-6057-4842-b375-1b7b63253b3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-01be-77de-9c1a-dcc12c55f442.webp",
      "image_media": {
        "alt_text": "The leasing office entrance with landscaping and signage.",
        "public_id": "019f3956-01be-77de-9c1a-dcc12c55f442",
        "storage_key": "property/6767906449166807/019f3956-01be-77de-9c1a-dcc12c55f442.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "The leasing office entrance with lush landscaping and clear signage, welcoming residents and visitors.",
      "link": "",
      "alt_text": "The leasing office entrance with landscaping and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3b3ffdf7-7cd4-4b84-aec3-335d289eb1be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-c970-72b9-b263-98cc4a1e8500.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex building exterior with parking lot and landscaping.",
        "public_id": "019f3955-c970-72b9-b263-98cc4a1e8500",
        "storage_key": "property/6767906449166807/019f3955-c970-72b9-b263-98cc4a1e8500.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover comfortable living at our apartment community, featuring a welcoming building exterior and convenient parking.",
      "link": "",
      "alt_text": "Aerial view of apartment complex building exterior with parking lot and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_421c9909-6ded-4257-9866-c4f97b7b06b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-c8d5-7659-8e92-52a270a43bf1.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and trees.",
        "public_id": "019f3955-c8d5-7659-8e92-52a270a43bf1",
        "storage_key": "property/6767906449166807/019f3955-c8d5-7659-8e92-52a270a43bf1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Charming apartment buildings with balconies and lush green trees, creating a serene community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aea3af6e-0678-4792-b1ad-d52a3317b81e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-e421-70a1-a6d6-fb2deeaf885e.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with balconies and blue sky.",
        "public_id": "019f3955-e421-70a1-a6d6-fb2deeaf885e",
        "storage_key": "property/6767906449166807/019f3955-e421-70a1-a6d6-fb2deeaf885e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Exterior view of a multi-unit apartment building featuring balconies, large windows, and vinyl siding under a clear blue sky.",
      "link": "",
      "alt_text": "Exterior of apartment building with balconies and blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_224e67bb-f3ab-4fa1-b8c8-47218acb728c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-e456-739a-96d7-804f0c6f570f.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a playground and parking lot.",
        "public_id": "019f3955-e456-739a-96d7-804f0c6f570f",
        "storage_key": "property/6767906449166807/019f3955-e456-739a-96d7-804f0c6f570f.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover comfortable living in this apartment complex, featuring a playground and ample parking for residents. Enjoy the community atmosphere and convenient amenities.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a playground and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_46308704-78c4-490e-9e26-ecdae32560e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-25f7-70ce-8b60-df6a826340d0.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with parking lots and trees.",
        "public_id": "019f3956-25f7-70ce-8b60-df6a826340d0",
        "storage_key": "property/6767906449166807/019f3956-25f7-70ce-8b60-df6a826340d0.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover comfortable living in this scenic apartment community, featuring ample parking and lush green spaces.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with parking lots and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_260a480b-2143-485e-95a8-9670b983a85e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-f624-748d-974c-d98544d15c8d.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex exterior with buildings, parking lots, and surrounding trees.",
        "public_id": "019f3955-f624-748d-974c-d98544d15c8d",
        "storage_key": "property/6767906449166807/019f3955-f624-748d-974c-d98544d15c8d.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Experience comfortable living in this beautiful apartment community, featuring well-maintained buildings, ample parking, and lush green spaces.",
      "link": "",
      "alt_text": "Aerial view of an apartment complex exterior with buildings, parking lots, and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e264d2e7-4f56-4d30-a31d-242c06a29abe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-206d-702d-807f-6882ab8c29a1.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex with surrounding trees and residential neighborhood.",
        "public_id": "019f3956-206d-702d-807f-6882ab8c29a1",
        "storage_key": "property/6767906449166807/019f3956-206d-702d-807f-6882ab8c29a1.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "An aerial view showcases the apartment complex nestled among lush trees, with a suburban neighborhood extending into the distance. This property offers a serene living environment.",
      "link": "",
      "alt_text": "Aerial view of an apartment complex with surrounding trees and residential neighborhood.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_24015657-6ca9-44d0-bc8e-a67cb22840c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-21da-727e-a637-09e507b5258d.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool and hot tub with lounge chairs and red umbrellas.",
        "public_id": "019f3956-21da-727e-a637-09e507b5258d",
        "storage_key": "property/6767906449166807/019f3956-21da-727e-a637-09e507b5258d.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling swimming pool or unwind in the soothing hot tub. Perfect for soaking up the sun or entertaining guests.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool and hot tub with lounge chairs and red umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1cdd66ca-35d8-49fa-ad46-7c44ea3710e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-1a91-7049-ada2-0edf64a7be29.webp",
      "image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and umbrellas on a sunny day.",
        "public_id": "019f3956-1a91-7049-ada2-0edf64a7be29",
        "storage_key": "property/6767906449166807/019f3956-1a91-7049-ada2-0edf64a7be29.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing on warm days.",
      "link": "",
      "alt_text": "Bright blue swimming pool with lounge chairs and umbrellas on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f2a18e9c-bd4c-44a7-abe4-e31ddb2564f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-b6dc-724a-bcff-efc3d9696b64.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge chairs with a building in the background at sunset.",
        "public_id": "019f3955-b6dc-724a-bcff-efc3d9696b64",
        "storage_key": "property/6767906449166807/019f3955-b6dc-724a-bcff-efc3d9696b64.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a relaxing evening by the pool, complete with comfortable lounge chairs and a beautiful sunset view.",
      "link": "",
      "alt_text": "Swimming pool and lounge chairs with a building in the background at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8ff2e9c7-fd25-41d0-9865-c8fa17e220d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-c4eb-77d8-9293-c49c301e7137.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and red umbrellas.",
        "public_id": "019f3955-c4eb-77d8-9293-c49c301e7137",
        "storage_key": "property/6767906449166807/019f3955-c4eb-77d8-9293-c49c301e7137.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded areas for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and red umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8f7d2db5-b3d9-46ca-b9f3-0e5ea789fe80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-c428-73ed-a720-39aedcc257d0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and hot tub area with lounge chairs and red umbrellas.",
        "public_id": "019f3955-c428-73ed-a720-39aedcc257d0",
        "storage_key": "property/6767906449166807/019f3955-c428-73ed-a720-39aedcc257d0.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, or relax in the soothing hot tub. Lounge chairs and umbrellas are available for your comfort.",
      "link": "",
      "alt_text": "Resort-style swimming pool and hot tub area with lounge chairs and red umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e29ad3d3-58cb-49bb-b293-953ed1d1566b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-01fa-7499-abe4-3fefc5d152f3.webp",
      "image_media": {
        "alt_text": "Loungers and umbrellas by the community pool and outdoor kitchen.",
        "public_id": "019f3956-01fa-7499-abe4-3fefc5d152f3",
        "storage_key": "property/6767906449166807/019f3956-01fa-7499-abe4-3fefc5d152f3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax by the sparkling community pool and enjoy outdoor dining with our built-in grill and bar area. Perfect for summer gatherings.",
      "link": "",
      "alt_text": "Loungers and umbrellas by the community pool and outdoor kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a234c0cb-a3e4-44bf-8075-946b8a0981af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-bd5c-71ed-91ba-58c44773cdef.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with a built-in grill and counter seating.",
        "public_id": "019f3955-bd5c-71ed-91ba-58c44773cdef",
        "storage_key": "property/6767906449166807/019f3955-bd5c-71ed-91ba-58c44773cdef.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor entertaining with our community grilling station, featuring a spacious counter and comfortable seating for gathering with friends.",
      "link": "",
      "alt_text": "Outdoor grilling station with a built-in grill and counter seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4137a116-368d-4d44-b05e-3a9d7ef3cbad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-1859-7404-8808-08defc776c44.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and fire hydrant.",
        "public_id": "019f3956-1859-7404-8808-08defc776c44",
        "storage_key": "property/6767906449166807/019f3956-1859-7404-8808-08defc776c44.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "This fenced-in dog park features agility equipment such as tunnels and hoops, a fire hydrant, and benches, providing a safe and fun space for pets.",
      "link": "",
      "alt_text": "Dog park with agility equipment and fire hydrant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f170bba0-1586-45f2-a058-b2bdac2ef0a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-83d5-723f-a696-a91a6be6c116.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures in front of apartment buildings.",
        "public_id": "019f3955-83d5-723f-a696-a91a6be6c116",
        "storage_key": "property/6767906449166807/019f3955-83d5-723f-a696-a91a6be6c116.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy fun outdoor activities at our community playground, featuring colorful slides and climbing structures for all ages.",
      "link": "",
      "alt_text": "Playground with slides and climbing structures in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4369b74e-8405-44e1-b578-3c099e4410c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-16c7-75bf-bd45-d1fed43a15be.webp",
      "image_media": {
        "alt_text": "Lobby with coffee bar, seating area, and large window overlooking property.",
        "public_id": "019f3956-16c7-75bf-bd45-d1fed43a15be",
        "storage_key": "property/6767906449166807/019f3956-16c7-75bf-bd45-d1fed43a15be.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Welcome guests in our stylish lobby, featuring a complimentary coffee bar and comfortable seating. Enjoy the bright, airy atmosphere.",
      "link": "",
      "alt_text": "Lobby with coffee bar, seating area, and large window overlooking property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c79e6968-8549-401b-95cc-fac37bbef198",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-81cb-755e-984a-72428a955975.webp",
      "image_media": {
        "alt_text": "Lobby area with coffee station, modern chairs, and a large window overlooking the exterior.",
        "public_id": "019f3955-81cb-755e-984a-72428a955975",
        "storage_key": "property/6767906449166807/019f3955-81cb-755e-984a-72428a955975.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax in our stylish lobby area, complete with a convenient coffee station and comfortable seating. Enjoy the natural light streaming in from the large window.",
      "link": "",
      "alt_text": "Lobby area with coffee station, modern chairs, and a large window overlooking the exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eda87616-2032-46eb-8a3f-2f0532e924b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-e453-71ec-bc2a-2c83e93bedba.webp",
      "image_media": {
        "alt_text": "Game room with foosball and shuffleboard tables, and a TV mounted on the wall.",
        "public_id": "019f3955-e453-71ec-bc2a-2c83e93bedba",
        "storage_key": "property/6767906449166807/019f3955-e453-71ec-bc2a-2c83e93bedba.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy friendly competition in our community game room, featuring foosball and shuffleboard tables, and a large screen TV for entertainment.",
      "link": "",
      "alt_text": "Game room with foosball and shuffleboard tables, and a TV mounted on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b17cffc9-bc9f-42ad-a436-575bb4a84399",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-b381-7466-b9f2-000327bd7d5f.webp",
      "image_media": {
        "alt_text": "Community game room with foosball table and arcade games.",
        "public_id": "019f3955-b381-7466-b9f2-000327bd7d5f",
        "storage_key": "property/6767906449166807/019f3955-b381-7466-b9f2-000327bd7d5f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy endless fun in our community game room, featuring a foosball table and classic arcade games.",
      "link": "",
      "alt_text": "Community game room with foosball table and arcade games.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_50dcc2f0-08a7-4c93-8045-c0d93ed29c0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-c269-71cb-a220-573d045fd071.webp",
      "image_media": {
        "alt_text": "Community game room with foosball table, shuffleboard, and arcade game.",
        "public_id": "019f3955-c269-71cb-a220-573d045fd071",
        "storage_key": "property/6767906449166807/019f3955-c269-71cb-a220-573d045fd071.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy endless entertainment in our vibrant community game room, featuring a foosball table, shuffleboard, and classic arcade games.",
      "link": "",
      "alt_text": "Community game room with foosball table, shuffleboard, and arcade game.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2c9a1ac0-eecf-4f10-837b-9a739ec8d26c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-eccd-73c4-92da-04c8cb7f639b.webp",
      "image_media": {
        "alt_text": "Community game room with foosball and pool tables and a television.",
        "public_id": "019f3955-eccd-73c4-92da-04c8cb7f639b",
        "storage_key": "property/6767906449166807/019f3955-eccd-73c4-92da-04c8cb7f639b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy our community game room, complete with foosball and pool tables, perfect for friendly competition or unwinding after a long day.",
      "link": "",
      "alt_text": "Community game room with foosball and pool tables and a television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_134b9212-3a8a-47cf-bf29-9b75e2557728",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-f9e0-7088-bb48-82693c700d08.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and stationary bike, overlooking the outdoor pool.",
        "public_id": "019f3955-f9e0-7088-bb48-82693c700d08",
        "storage_key": "property/6767906449166807/019f3955-f9e0-7088-bb48-82693c700d08.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, ellipticals, and a stationary bike. Enjoy a refreshing view of the outdoor pool while you work out.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, and stationary bike, overlooking the outdoor pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1d9005dd-8ff2-4a10-8459-aa8265f1bc86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-b917-7348-a540-e8459e10432f.webp",
      "image_media": {
        "alt_text": "Fitness center with free weights, weight machines, treadmills, and a bench, overlooking a swimming pool.",
        "public_id": "019f3955-b917-7348-a540-e8459e10432f",
        "storage_key": "property/6767906449166807/019f3955-b917-7348-a540-e8459e10432f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a wide range of cardio and weight training equipment. Enjoy your workout with a view of the sparkling outdoor pool.",
      "link": "",
      "alt_text": "Fitness center with free weights, weight machines, treadmills, and a bench, overlooking a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ce621c5b-ba5e-437f-a207-ca7cd3986a0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-a21f-7468-95c6-00021c87a138.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, weight machines, and yoga balls.",
        "public_id": "019f3955-a21f-7468-95c6-00021c87a138",
        "storage_key": "property/6767906449166807/019f3955-a21f-7468-95c6-00021c87a138.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines, free weights, and space for yoga and stretching.",
      "link": "",
      "alt_text": "Fitness center with treadmills, weight machines, and yoga balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ea3ff1cb-5775-4129-8e58-5f9e1886bc05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-a5dd-7621-a2e1-38fc8f898b5d.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances including a dishwasher and oven, and a sink with a modern faucet.",
        "public_id": "019f3955-a5dd-7621-a2e1-38fc8f898b5d",
        "storage_key": "property/6767906449166807/019f3955-a5dd-7621-a2e1-38fc8f898b5d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark wood cabinetry, a stainless steel dishwasher, oven, and range hood, complemented by a sleek sink and faucet.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances including a dishwasher and oven, and a sink with a modern faucet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e09d5a45-0633-45a5-a55a-fa06fea7d185",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-00f9-73fa-b397-dd005abdc492.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator, dishwasher, and sink in an apartment kitchen.",
        "public_id": "019f3956-00f9-73fa-b397-dd005abdc492",
        "storage_key": "property/6767906449166807/019f3956-00f9-73fa-b397-dd005abdc492.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring stainless steel appliances, ample cabinet space, and a view into the living area.",
      "link": "",
      "alt_text": "Stainless steel refrigerator, dishwasher, and sink in an apartment kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2c2360c3-31ce-49b2-8e4a-b69f4d426881",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-83ea-7618-95d2-1d0b66c2dfa0.webp",
      "image_media": {
        "alt_text": "Kitchen island with dark wood cabinets and white countertop, stainless steel refrigerator, and a living room with a fireplace and large windows.",
        "public_id": "019f3955-83ea-7618-95d2-1d0b66c2dfa0",
        "storage_key": "property/6767906449166807/019f3955-83ea-7618-95d2-1d0b66c2dfa0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a modern kitchen with a breakfast bar, a cozy fireplace, and ample natural light.",
      "link": "",
      "alt_text": "Kitchen island with dark wood cabinets and white countertop, stainless steel refrigerator, and a living room with a fireplace and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51cb5a80-2f33-44a6-8512-37f509ba9d49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-251f-76ef-961f-5bffa1999639.webp",
      "image_media": {
        "alt_text": "Kitchen area with dark wood cabinets, stainless steel appliances, and a breakfast bar.",
        "public_id": "019f3956-251f-76ef-961f-5bffa1999639",
        "storage_key": "property/6767906449166807/019f3956-251f-76ef-961f-5bffa1999639.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark wood cabinetry, sleek countertops, stainless steel appliances, and a convenient breakfast bar for dining or entertaining.",
      "link": "",
      "alt_text": "Kitchen area with dark wood cabinets, stainless steel appliances, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_184f4a2f-564a-44f9-9b97-335f62727c44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-eca7-715a-815e-a78e2cc949c5.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and kitchen island",
        "public_id": "019f3955-eca7-715a-815e-a78e2cc949c5",
        "storage_key": "property/6767906449166807/019f3955-eca7-715a-815e-a78e2cc949c5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace and an open-concept kitchen with an island.",
      "link": "",
      "alt_text": "Living room with fireplace and kitchen island",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_adf28263-9f90-4fa7-abf3-7a9fbfb3b6a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-a4f1-71d8-aaf0-abb89c73af9d.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and large window",
        "public_id": "019f3955-a4f1-71d8-aaf0-abb89c73af9d",
        "storage_key": "property/6767906449166807/019f3955-a4f1-71d8-aaf0-abb89c73af9d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, a large window with blinds, and plush carpeting. Perfect for relaxing evenings.",
      "link": "",
      "alt_text": "Living room with fireplace and large window",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a3ae318a-995c-464a-a298-144a92ca87b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-8401-74a8-9a30-014187bcc4a8.webp",
      "image_media": {
        "alt_text": "Window seat with blinds and a door leading to a balcony.",
        "public_id": "019f3955-8401-74a8-9a30-014187bcc4a8",
        "storage_key": "property/6767906449166807/019f3955-8401-74a8-9a30-014187bcc4a8.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Enjoy natural light and a cozy window seat in this apartment. The door leads to a private balcony, perfect for relaxing outdoors.",
      "link": "",
      "alt_text": "Window seat with blinds and a door leading to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_953b81d7-7c4a-4a10-aa3b-1d6c2237666b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-a637-739a-b21d-d6ee26cab700.webp",
      "image_media": {
        "alt_text": "Bedroom with large closet and window",
        "public_id": "019f3955-a637-739a-b21d-d6ee26cab700",
        "storage_key": "property/6767906449166807/019f3955-a637-739a-b21d-d6ee26cab700.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a large sliding door closet and a window with blinds, offering a comfortable living space.",
      "link": "",
      "alt_text": "Bedroom with large closet and window",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_802752d9-06cb-46f6-a9e2-684e7f9ada8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-2097-705e-a859-959a28e56696.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with a shelf above.",
        "public_id": "019f3956-2097-705e-a859-959a28e56696",
        "storage_key": "property/6767906449166807/019f3956-2097-705e-a859-959a28e56696.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for easy laundry days. Includes overhead shelving for storage.",
      "link": "",
      "alt_text": "In-unit washer and dryer with a shelf above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_05e68a9f-ce19-4c50-a2f1-ca98f6e14a86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3956-02aa-731b-9c7d-0a3fe294a7ad.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, vanity, and mirror.",
        "public_id": "019f3956-02aa-731b-9c7d-0a3fe294a7ad",
        "storage_key": "property/6767906449166807/019f3956-02aa-731b-9c7d-0a3fe294a7ad.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and comfort of this modern bathroom, featuring a bathtub, toilet, and spacious vanity with a large mirror.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, vanity, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a582748d-28a0-4463-a975-6f1003423288",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019f3955-8492-7493-badd-9c7c3839f493.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with dark wood cabinets, white countertop, sink, and three-light fixture.",
        "public_id": "019f3955-8492-7493-badd-9c7c3839f493",
        "storage_key": "property/6767906449166807/019f3955-8492-7493-badd-9c7c3839f493.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Renovated bathroom featuring a spacious vanity with ample storage, a modern sink, and bright overhead lighting.",
      "link": "",
      "alt_text": "Bathroom vanity with dark wood cabinets, white countertop, sink, and three-light fixture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c08827d8-b0a1-4bcd-aa14-18a9fe0200af",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Crestline Elementary School",
      "poi_type": "Education",
      "poi_address": "13003 SE 7th St, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJ0U9EzZ3OqkER5Gr7aTIE11A",
      "poi_item_slug": "crestline-elementary-school",
      "poi_latitude": "45.6155659",
      "poi_longitude": "-122.5392236",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-604-3325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d1-f9cb-73c9-817a-157c3a0c74ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-f9cb-73c9-817a-157c3a0c74ae",
        "storage_key": "property/6767906449166807/019d02d1-f9cb-73c9-817a-157c3a0c74ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0U9EzZ3OqkER5Gr7aTIE11A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_76ff986a-bff9-416a-80d5-fb3f5e7a8e67",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Wy'east Middle School",
      "poi_type": "Education",
      "poi_address": "1112 SE 136th Ave, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJOa_P_-CklVQRw1f08JQJiHY",
      "poi_item_slug": "wyeast-middle-school",
      "poi_latitude": "45.612899299999995",
      "poi_longitude": "-122.53407050000001",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-604-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d1-f9cb-73c9-817a-157c3a0c74ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-f9cb-73c9-817a-157c3a0c74ae",
        "storage_key": "property/6767906449166807/019d02d1-f9cb-73c9-817a-157c3a0c74ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOa_P_-CklVQRw1f08JQJiHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a825d21b-13e6-4f70-9225-06ace29bc097",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "FVRLibraries - Cascade Park Community Library",
      "poi_type": "Education",
      "poi_address": "600 NE 136th Ave, Vancouver, WA 98684, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJMX3uxySllVQRTXdW-K9joFs",
      "poi_item_slug": "fvrlibraries-cascade-park-community-library",
      "poi_latitude": "45.625075",
      "poi_longitude": "-122.535461",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-906-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d1-f9cb-73c9-817a-157c3a0c74ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-f9cb-73c9-817a-157c3a0c74ae",
        "storage_key": "property/6767906449166807/019d02d1-f9cb-73c9-817a-157c3a0c74ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMX3uxySllVQRTXdW-K9joFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_655a91b5-2618-4efe-9301-866cbc6d43b1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Riverview Elementary School",
      "poi_type": "Education",
      "poi_address": "12601 SE Riveridge Dr, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJl5o8MPuklVQR0Bl3SX3BHTw",
      "poi_item_slug": "riverview-elementary-school",
      "poi_latitude": "45.6065919",
      "poi_longitude": "-122.5412369",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-604-6625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d1-f9cb-73c9-817a-157c3a0c74ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-f9cb-73c9-817a-157c3a0c74ae",
        "storage_key": "property/6767906449166807/019d02d1-f9cb-73c9-817a-157c3a0c74ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl5o8MPuklVQR0Bl3SX3BHTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ccc439cb-6270-4b0a-8bb6-d2ff4a895c43",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Legacy High School",
      "poi_type": "Education",
      "poi_address": "13300 NE 9th St, Vancouver, WA 98684, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJoVzijUqllVQRMM4cVOBFBkA",
      "poi_item_slug": "legacy-high-school",
      "poi_latitude": "45.628894",
      "poi_longitude": "-122.5364429",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-604-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d1-f9cb-73c9-817a-157c3a0c74ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-f9cb-73c9-817a-157c3a0c74ae",
        "storage_key": "property/6767906449166807/019d02d1-f9cb-73c9-817a-157c3a0c74ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoVzijUqllVQRMM4cVOBFBkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c8f4dc0e-9282-4a84-8844-e1572ca7b1fe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Mountain View High School",
      "poi_type": "Education",
      "poi_address": "1500 SE Blairmont Dr, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJs996O9uklVQRexTRrf4fktE",
      "poi_item_slug": "mountain-view-high-school",
      "poi_latitude": "45.6110366",
      "poi_longitude": "-122.5201981",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-604-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d1-f9cb-73c9-817a-157c3a0c74ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-f9cb-73c9-817a-157c3a0c74ae",
        "storage_key": "property/6767906449166807/019d02d1-f9cb-73c9-817a-157c3a0c74ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs996O9uklVQRexTRrf4fktE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8444fb92-88fa-4014-bc0d-e622f5554995",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Cascade Middle School",
      "poi_type": "Education",
      "poi_address": "13900 NE 18th St, Vancouver, WA 98684, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJiQQ7djWllVQR-hhRl5us2Ho",
      "poi_item_slug": "cascade-middle-school",
      "poi_latitude": "45.6373951",
      "poi_longitude": "-122.5285466",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-604-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d1-f9cb-73c9-817a-157c3a0c74ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-f9cb-73c9-817a-157c3a0c74ae",
        "storage_key": "property/6767906449166807/019d02d1-f9cb-73c9-817a-157c3a0c74ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiQQ7djWllVQR-hhRl5us2Ho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_422b1fa4-5839-43f5-90a3-30f786f660c9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "McKenzie Stadium",
      "poi_type": "Entertainment",
      "poi_address": "2211 NE 138th Ave, Vancouver, WA 98684, USA",
      "poi_short_description": "Vast stadium with a covered home section that's also home to several high schools' football teams.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d2-49e9-760b-9fd4-50930cefb774.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-49e9-760b-9fd4-50930cefb774",
        "storage_key": "property/6767906449166807/019d02d2-49e9-760b-9fd4-50930cefb774.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sites.google.com/evergreenps.org/mckenziestadium",
      "poi_directions_map_url": "https://maps.google.com/?cid=10328496315937824707&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mckenzie-stadium",
      "poi_latitude": "45.6398432",
      "poi_longitude": "-122.5280925",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 360-604-6828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d2-00c0-76a2-bdc2-7bf5378b439f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-00c0-76a2-bdc2-7bf5378b439f",
        "storage_key": "property/6767906449166807/019d02d2-00c0-76a2-bdc2-7bf5378b439f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2SRIm0qllVQRw59nN60wVo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_2b2f84b5-8dd3-4aca-b881-ba5afb90622e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Pacific Northwest Pet ER & Specialty Center",
      "poi_type": "Health and Wellness",
      "poi_address": "815 SE 160th Ave, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.pacificnwvets.com/?y_source=1_MjkzNDQzMjMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12027949979183581833&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pacific-northwest-pet-er--specialty-center",
      "poi_latitude": "45.6147366",
      "poi_longitude": "-122.5059478",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 360-635-5302",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-00b7-75b9-9fce-9ab7b98bb658",
        "storage_key": "property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeRmDzFellVQRiYpnfcfc66Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_e735f389-39a9-4144-8cda-d8a98f44d11f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "800 SE Tech Center Dr, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d1-d58b-71da-bc7b-b7734b1eb314.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-d58b-71da-bc7b-b7734b1eb314",
        "storage_key": "property/6767906449166807/019d02d1-d58b-71da-bc7b-b7734b1eb314.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/vancouver-wa/columbia-tech-center-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=639379064530645413&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "45.6143137",
      "poi_longitude": "-122.4965063",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 360-514-8381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-00b7-75b9-9fce-9ab7b98bb658",
        "storage_key": "property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEULcKs2klVQRpbErIt-H3wg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_feff2953-81a3-4e21-b783-e19088c8fe71",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8024 E Mill Plain Blvd, Vancouver, WA 98664, USA",
      "poi_short_description": "Chain gym featuring exercise machines, tanning beds, and massage chairs, plus a membership requirement.",
      "poi_long_description": "People say this gym offers a variety of workout equipment and amenities, such as massage chairs. They also highlight the friendly and helpful staff, and the clean and welcoming atmosphere.\n\nOther reviews mention the cancellation process can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d2-4e92-7241-b333-ba8700a1c174.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-4e92-7241-b333-ba8700a1c174",
        "storage_key": "property/6767906449166807/019d02d2-4e92-7241-b333-ba8700a1c174.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/vancouver-wa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6808317091596307094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "45.6256",
      "poi_longitude": "-122.59014",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 360-448-2277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-00b7-75b9-9fce-9ab7b98bb658",
        "storage_key": "property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaQwkZpyllVQRlorRolIAfF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_976777b2-68b7-4397-87c4-ed9436e230b8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Kaiser Permanente Cascade Park Medical Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12607 SE Mill Plain Blvd, Vancouver, WA 98684, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJKQI81RillVQRZr_VmdeCLrE",
      "poi_item_slug": "kaiser-permanente-cascade-park-medical-office",
      "poi_latitude": "45.6184655",
      "poi_longitude": "-122.5416147",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 800-813-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-00b7-75b9-9fce-9ab7b98bb658",
        "storage_key": "property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKQI81RillVQRZr_VmdeCLrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0a7dde11-bc71-45ad-8f8c-f869fa18f4ff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "PeaceHealth Southwest Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 NE Mother Joseph Pl, Vancouver, WA 98664, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJz_zp5p-llVQR_e1tOaBkZ9E",
      "poi_item_slug": "peacehealth-southwest-medical-center",
      "poi_latitude": "45.624201",
      "poi_longitude": "-122.58004620000001",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-514-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-00b7-75b9-9fce-9ab7b98bb658",
        "storage_key": "property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz_zp5p-llVQR_e1tOaBkZ9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_99469b88-9d1a-470c-8552-157dd798ba86",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "HP",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1115 SE 164th Ave #210, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.hp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13524437188604611031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hp",
      "poi_latitude": "45.61335099999999",
      "poi_longitude": "-122.5020704",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 360-212-7469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-00b7-75b9-9fce-9ab7b98bb658",
        "storage_key": "property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn4-ddM6klVQR10ncrfdzsLs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ea34c6b9-49cb-4a2d-b4d3-158592af5c05",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "PeaceHealth System Services Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1115 SE 164th Ave, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.peacehealth.org/shared-services-center?utm_source=gbp&utm_medium=organic&utm_content=SYS01&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4830498570983912327&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "peacehealth-system-services-center",
      "poi_latitude": "45.6135749",
      "poi_longitude": "-122.5009231",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 360-729-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-00b7-75b9-9fce-9ab7b98bb658",
        "storage_key": "property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWflmus2klVQRhzOHc9tgCUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d973a299-fafc-4f7b-9029-51133ad8befc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Columbia Tech Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17700 SE Mill Plain Blvd Suite 120, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.columbiatechcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14166542181240851383&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "columbia-tech-center",
      "poi_latitude": "45.6163336",
      "poi_longitude": "-122.4917123",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-00b7-75b9-9fce-9ab7b98bb658",
        "storage_key": "property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo_lTGDO7lVQRt8tyaA6rmcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7fbe773d-02e6-4ea3-a441-cbcab78fd538",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Banfield Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "18101 SE 6th Way, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJg2vhEDG7lVQRG6KodGooLxQ",
      "poi_item_slug": "banfield-headquarters",
      "poi_latitude": "45.6164414",
      "poi_longitude": "-122.4855383",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 800-838-6738",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-00b7-75b9-9fce-9ab7b98bb658",
        "storage_key": "property/6767906449166807/019d02d2-00b7-75b9-9fce-9ab7b98bb658.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg2vhEDG7lVQRG6KodGooLxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_35b7fd39-7600-4570-8971-4de2a58fb106",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Biddlewood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "SE Riveridge Dr, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJT_ICYPyklVQRgV6jnD3JhjE",
      "poi_item_slug": "biddlewood-park",
      "poi_latitude": "45.607308599999996",
      "poi_longitude": "-122.548529",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-487-8311",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJT_ICYPyklVQRgV6jnD3JhjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_86bdbcaf-f420-4c48-a0c3-8b23faaaaaac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "LeRoy Haagen Memorial Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13412 NE LeRoy Haagen Memorial Drive, Vancouver, WA 98684, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJETcahDmllVQRqobL5B1L550",
      "poi_item_slug": "leroy-haagen-memorial-community-park",
      "poi_latitude": "45.6309609",
      "poi_longitude": "-122.5377879",
      "poi_miles_from_property": "1.0",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-487-8311",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJETcahDmllVQRqobL5B1L550",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_61f6c8d6-8a0b-4d11-9dc3-ed712dad1ccc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "12601 SE 2nd Cir, Vancouver, WA 98684, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fries, and Texas toast. They also highlight the good value, fast service, and friendly staff.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d1-a405-7095-93f2-901d99bb7aac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-a405-7095-93f2-901d99bb7aac",
        "storage_key": "property/6767906449166807/019d02d1-a405-7095-93f2-901d99bb7aac.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/wa/vancouver/12601-southeast-2nd-circle",
      "poi_directions_map_url": "https://maps.google.com/?cid=13681081531179168541&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "45.6202088",
      "poi_longitude": "-122.5419318",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 253-256-6989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d1-f9b4-7119-ad4c-032c0f8013c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-f9b4-7119-ad4c-032c0f8013c9",
        "storage_key": "property/6767906449166807/019d02d1-f9b4-7119-ad4c-032c0f8013c9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg4MY5HullVQRHXMXySr33L0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_8cebd107-30fb-4731-a0f2-b73100b31ea0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Chuck's Fresh Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "13215 SE Mill Plain Blvd, Vancouver, WA 98684, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJea_P5SGllVQRYAraueUvGP8",
      "poi_item_slug": "chucks-fresh-market",
      "poi_latitude": "45.6181056",
      "poi_longitude": "-122.53707220000001",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-597-2700",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJea_P5SGllVQRYAraueUvGP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d0eaa633-88f6-4662-9f9b-0f11e3131e3b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Columbia Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "13411 SE Mill Plain Blvd, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJ22TcTiCllVQR8HyGsgAGqpI",
      "poi_item_slug": "columbia-square",
      "poi_latitude": "45.6185154",
      "poi_longitude": "-122.53484990000001",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ22TcTiCllVQR8HyGsgAGqpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_615090e4-9e53-47e5-b2eb-08e6d5857752",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Cascade Park Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "305 SE Chkalov Dr, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJ-0p1ghqllVQRaW8hf_qzKzA",
      "poi_item_slug": "cascade-park-plaza",
      "poi_latitude": "45.6197242",
      "poi_longitude": "-122.55359779999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ-0p1ghqllVQRaW8hf_qzKzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5dd2ef33-e4f9-4e41-9747-bc28d39ed1d0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "305 SE Chkalov Dr, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJievciRCllVQRrmDSE197njk",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "45.619316999999995",
      "poi_longitude": "-122.5529613",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-883-9000",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJievciRCllVQRrmDSE197njk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_db1e8188-2989-48ca-8024-81f4ecaf4496",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "11325 SE Mill Plain Blvd, Vancouver, WA 98684, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJtzwwCRCllVQRmOxqdUw2IPM",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "45.6194821",
      "poi_longitude": "-122.55619970000001",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-253-7053",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJtzwwCRCllVQRmOxqdUw2IPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1d9d255f-ee13-491a-ad77-63eb997eaad5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "905 NE 136th Ave, Vancouver, WA 98684, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "Shoppers say this supermarket offers a wide variety of groceries, including fresh produce, quality meats, and bulk grains and spices, at affordable prices. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nSome reviews mention the self-checkout can be unpleasant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d1-b37e-743b-9cf9-b2cd3c5fc5cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-b37e-743b-9cf9-b2cd3c5fc5cf",
        "storage_key": "property/6767906449166807/019d02d1-b37e-743b-9cf9-b2cd3c5fc5cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7173165391919666912&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "45.629333",
      "poi_longitude": "-122.531783",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 360-254-5388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d1-fa89-70f3-86bd-747fb69b9dbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-fa89-70f3-86bd-747fb69b9dbd",
        "storage_key": "property/6767906449166807/019d02d1-fa89-70f3-86bd-747fb69b9dbd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzXJhcDqllVQR4FZ_POszjGM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_05e4d0da-9d67-4c2c-9d73-1ef693604691",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Fisher's Landing Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "2100 SE 164th Ave, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJVVEKL6SllVQRL8Va2gf6KVA",
      "poi_item_slug": "fishers-landing-marketplace",
      "poi_latitude": "45.6051084",
      "poi_longitude": "-122.50526190000001",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 503-245-1976",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJVVEKL6SllVQRL8Va2gf6KVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d25cc580-d8f8-4e55-9e34-91eb392ff104",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Columbia Crossing Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "16405 - 16801 SE Mill Plain Blvd, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJ4dxjgc2klVQRuQPIMu-FNls",
      "poi_item_slug": "columbia-crossing-shopping-center",
      "poi_latitude": "45.6158605",
      "poi_longitude": "-122.50010440000001",
      "poi_miles_from_property": "2.0",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ4dxjgc2klVQRuQPIMu-FNls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_109e436c-4c52-413f-b195-f8b13b0c83f4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "poi_name": "Stardust Diner",
      "poi_type": "Restaurants",
      "poi_address": "1110 SE 164th Ave, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJ7VBv_c2klVQRwrCultkP0nE",
      "poi_item_slug": "stardust-diner",
      "poi_latitude": "45.6138104",
      "poi_longitude": "-122.5045965",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-828-1648",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d1-f9b4-7119-ad4c-032c0f8013c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-f9b4-7119-ad4c-032c0f8013c9",
        "storage_key": "property/6767906449166807/019d02d1-f9b4-7119-ad4c-032c0f8013c9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7VBv_c2klVQRwrCultkP0nE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    }
  ],
  "office_hours": [
    {
      "id": "custom_e171beb6-66e6-4efe-8c61-cd4913f23e1d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_eeb7f347-dc99-430e-ab1c-a314ccff041e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_9064dbfe-38ec-4e01-8787-db246cef78ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_b79f1cd3-914d-4210-ac22-6c626d1717f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_1b008400-262c-4cab-90d2-7f18f054a006",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_82616d26-6b86-41c4-b1d6-93df7f97b278",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "rating": "5.0",
      "name": "Paul Smyth",
      "text": "Al was friendly and efficient. Everything went smoothly. Megan in the office always greeted us with a smile. Both She and Al made our experience living at Passage a positive one.",
      "date": "2025-07-04",
      "title": ""
    },
    {
      "id": "custom_dc68e5a7-2869-4953-8cb3-fc747470b45c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "rating": "5.0",
      "name": "Chrissy King",
      "text": "This complex by far has been the best I have lived in yet! Megan is so sweet and accommodating, always making sure that she does whatever she can to make everyone happy. Her pleasant and inviting personality along with her genuine smile made me feel at ease that I made the best choice for me and my family to live here. I have never met anyone as kind as Megan. Albert, the maintenance guy is professional and superb! He is very attentive and definitely knows what he is doing when it comes to taking care of/fixing minor things in the complex. Both employees have worked here several years which speaks volumes to me to know that there isn't a turnover in staffing and they actually care about the community. Everyone who lives here, that I have personally met is respectful, kind and courteous. I'm very pleased to call Passage \"My home.\"",
      "date": "2025-02-17",
      "title": ""
    },
    {
      "id": "custom_8ebf83e8-fb16-4911-a84e-ae61a88dcdd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "rating": "5.0",
      "name": "Suzanne Maloney",
      "text": "Lee was professional and friendly and got us back up and running again without any trouble!  Great job!",
      "date": "2025-08-30",
      "title": ""
    },
    {
      "id": "custom_88dd5ed6-61cc-417c-9ac4-e28e4cc6d171",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "rating": "5.0",
      "name": "Savannah King",
      "text": "The office and maintenance staff are amazing!! We moved here from out of state, and Megan and the other ladies in the office were so friendly, patient, and helpful throughout the moving process. Additionally, Albert the maintenance guy is awesome! He's super kind, funny, and helpful. Any maintenance request we need help with is always fixed super quickly! I've lived in lots of apartments, but this one is definitely shaping up to be my favorite. Thanks, you guys!",
      "date": "2024-04-09",
      "title": ""
    },
    {
      "id": "custom_e3173217-fff3-4f80-8450-847dce5b3ef0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "rating": "5.0",
      "name": "John Stushek",
      "text": "The amazing and easy transition into the community was far beyond what I had intisapated. I had been looking for a new home for a while with excitement and disappointment. The staff here had me at how can we help you. You can truly see they care about this community. They have made me personally feel like I'm at home. Thank you",
      "date": "2025-02-17",
      "title": ""
    },
    {
      "id": "custom_f9622717-1805-4771-b29d-e8c453a6746b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "rating": "5",
      "name": "   Zachary V.",
      "text": "The team is really supportive and kind here, and it's a cozy place to live.",
      "date": "2026-04-28",
      "title": "false"
    },
    {
      "id": "custom_9aeba53d-276a-4790-a731-f23cb9c5215a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "rating": "5",
      "name": "  David M.",
      "text": "Lee, the maintenance guy was great and answered my request the following day.  He is personal, friendly and seems knowledgeable.",
      "date": "2026-03-28",
      "title": "false"
    },
    {
      "id": "custom_03096bd1-e4db-4266-9999-df3e51b48eb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "rating": "5",
      "name": "   Igal Z.",
      "text": "Magen was great in taking care of all the details - Thank you",
      "date": "2026-04-28",
      "title": "false"
    },
    {
      "id": "custom_531f66ef-e50a-4c00-afe0-0888f47b9234",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "rating": "5",
      "name": "Kate R.",
      "text": "Our maintenance worker is not only quick, he is incredibly friendly. He does an amazing job!",
      "date": "2025-12-28",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_50a2781d-ed11-47a4-89b9-62664c96a1c3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d3-4aca-72fe-85e0-e781bc789a57.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with fireplace and large window, adjacent to kitchen with black refrigerator.",
        "public_id": "019d02d3-4aca-72fe-85e0-e781bc789a57",
        "storage_key": "property/6767906449166807/019d02d3-4aca-72fe-85e0-e781bc789a57.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "2BR, 1BA - Riveridge",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3FingBM62tL"
    },
    {
      "id": "custom_0a024ad6-0481-454b-94f1-801a3c6cf17d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d2-6e87-728b-8f91-6903771d94e7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a fireplace and a doorway leading to the kitchen.",
        "public_id": "019d02d2-6e87-728b-8f91-6903771d94e7",
        "storage_key": "property/6767906449166807/019d02d2-6e87-728b-8f91-6903771d94e7.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "2BR, 2BA - Wildwood",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=6MJfpkdoUBV"
    },
    {
      "id": "custom_6df8308b-6327-4216-b4e0-7cb5d53a7360",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166807/019d02d3-4a33-714b-85f2-4fd32ff33292.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living room and kitchen area with carpeted floors, a balcony door, and dark wood cabinets.",
        "public_id": "019d02d3-4a33-714b-85f2-4fd32ff33292",
        "storage_key": "property/6767906449166807/019d02d3-4a33-714b-85f2-4fd32ff33292.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2BA - Cascade",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=fpB5QvCGd3s"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019fa4c3-bf07-7629-a7f8-ebd2ee44a2b1",
      "lead_source": "LANDING_PAGE",
      "name": "Passage Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807"
    },
    {
      "lead_collector_id": "019fa4c3-c08a-72cc-9bc6-5670c07120c8",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Passage Website",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "apartments-with-in-unit-laundry-vancouver-wa",
      "search_query": "apartments with in-unit laundry Vancouver WA",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Vancouver, WA",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry in Vancouver, WA. These apartments offer appliances designed to fit your lifestyle with modern amenities.",
      "page_copy": "Discover the perfect blend of comfort and convenience at Passage, where each apartment is equipped with in-unit laundry. Located in Clark County, our Vancouver, WA community ensures modern living with stainless steel appliances, including a washer and dryer in every unit. Say goodbye to laundry day woes and embrace this time-saving feature.\n\nBeyond the practicality of in-unit laundry, our Passage apartments offer residents access to a host of desirable amenities. Unwind in our state-of-the-art fitness center, store your belongings in large closets, and enjoy the security of an available garage. Experience the ideal combination of modern comfort and daily convenience at Passage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry: Vancouver, WA",
      "seo_description": "Discover Passage in Vancouver, WA, offering apartments with in-unit laundry and modern amenities for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "luxury-pool-apartments-clark-county",
      "search_query": "luxury pool apartments Clark County",
      "category": "Amenity",
      "h1_title": "Luxury Pool Apartments in Clark County",
      "h2_subtitle": "Find luxury pool apartments in Clark County with premium amenities. Enjoy style and comfort in our upscale community.",
      "page_copy": "Welcome to Passage, where grandeur meets relaxation in the heart of Clark County. Our luxury pool apartments offer a serene escape with high-end amenities tailored for your comfort. Dive into relaxation with our lavish pool area, designed to provide a resort-like experience steps from your doorstep.\n\nEmbrace a lifestyle of elegance and convenience, surrounded by fabulous amenities like a state-of-the-art fitness center, ample living space with large closets, and garage parking options. Each apartment at Passage is crafted with premium features, including in-unit washers and dryers, modern refrigerators, and sleek interiors that promise to elevate your living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Pool Apartments in Clark County",
      "seo_description": "Experience Passage's luxury pool apartments in Clark County, complete with elegant amenities and stylish living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "apartments-with-private-balcony-vancouver-wa",
      "search_query": "apartments with private balcony Vancouver WA",
      "category": "Amenity",
      "h1_title": "Apartments with Private Balconies in Vancouver, WA",
      "h2_subtitle": "Find the ideal apartments with private balconies in Vancouver, WA. Enjoy personal outdoor retreats in our tranquil community.",
      "page_copy": "Passage invites you to experience serene living with our apartments featuring private balconies, nestled in the scenic surrounds of Vancouver, WA. Each unit offers a personal outdoor retreat where you can unwind amidst the peace of our lush landscape. These balconies provide the perfect space to relax, entertain, or simply soak in the Pacific Northwest beauty.\n\nApart from balconies, Passage enhances your lifestyle with top-notch amenities like a fully equipped fitness center, spacious closets, and modern in-unit laundry facilities. Enjoy the convenience of garage parking and a refrigerator in your stylish kitchen. Make Passage your home and savor the blend of outdoor charm and indoor comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Vancouver, WA Apartments with Private Balconies",
      "seo_description": "Discover apartments with private balconies at Passage in Vancouver, WA, featuring amenities for a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "gym-fitness-center-apartments-vancouver-98683",
      "search_query": "gym and fitness center apartments Vancouver 98683",
      "category": "Amenity",
      "h1_title": "Gym & Fitness Center Apartments in Vancouver 98683",
      "h2_subtitle": "Explore apartments with a gym and fitness center in Vancouver's 98683 area. Achieve your fitness goals with ease at Passage.",
      "page_copy": "Welcome to Passage. Our apartments, located in the vibrant 98683 area of Vancouver, offer residents access to a top-tier gym and fitness center. Our on-site facilities provide a convenient space for workouts and exercise without leaving the community.\n\nIn addition to a state-of-the-art fitness center, Passage offers renters large closets, garage parking, and in-unit washers and dryers for ultimate convenience. Enjoy modern kitchens equipped with a refrigerator, ensuring every aspect of your daily life is catered to within our community. Reserve your spot at Passage and elevate your living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Vancouver 98683 Apartments with Gym & Fitness Center",
      "seo_description": "Discover Passage's Vancouver 98683 apartments, complete with a gym and fitness center, for a lifestyle of health and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-playground-clark-county",
      "search_query": "pet-friendly apartments with playground Clark County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Playground in Clark County",
      "h2_subtitle": " Discover pet-friendly apartments with a playground in Clark County. Passage offers convenient amenities and comfortable apartment features in Vancouver, WA.",
      "page_copy": "At Passage, we understand that pets are an important part of the household, which is why we're proud to offer pet-friendly apartments in Clark County. Our community features a variety of outdoor amenities, including a playground and inviting spaces for enjoying time outside.\n\nBeyond our pet-friendly features, Passage offers a range of apartment and community amenities, including spacious closets, in-unit washers and dryers, a modern fitness center, garage parking, and fully equipped kitchens with refrigerators. Discover comfortable apartment living and convenient amenities at Passage in Vancouver, WA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Playground in Clark County",
      "seo_description": "Find pet-friendly apartments with a playground at Passage, located in Clark County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-vancouver-wa",
      "search_query": "two bedroom apartments in Vancouver WA",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Vancouver, WA",
      "h2_subtitle": "Explore spacious two bedroom apartments in Vancouver, WA. You'll find comfort and style at Passage, your new home awaits!",
      "page_copy": "Welcome to Passage, featuring spacious two-bedroom apartments in Vancouver, WA. Each apartment is thoughtfully designed to offer a blend of comfort, style, and functionality, with versatile living spaces and convenient features for everyday living.\n\nAt Passage, residents can enjoy a variety of apartment and community amenities, including large closets, in-unit washers and dryers, a fully equipped fitness center, garage parking, and modern kitchens with refrigerators. Make Passage your home and discover comfortable two-bedroom apartment living in Vancouver, WA.\n",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Explore Two Bedroom Apartments in Vancouver, WA",
      "seo_description": "Discover spacious two bedroom apartments at Passage in Vancouver, WA. Enjoy premium amenities and a convenient lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-98683",
      "search_query": "three bedroom apartments near 98683",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 98683",
      "h2_subtitle": "Discover spacious three bedroom apartments near the 98683 area. Experience comfort and convenience at Passage.",
      "page_copy": "Searching for a three-bedroom apartment near Vancouver’s 98683 zip code? Discover Passage. Our community offers generously sized three-bedroom apartments with additional living space and thoughtfully designed layouts that combine comfort, style, and functionality.\n\nAt Passage, residents have access to a variety of apartment features and community amenities, including a state-of-the-art fitness center, large closets, convenient in-unit washers and dryers, garage parking, and fully equipped kitchens with refrigerators. Discover spacious three-bedroom apartment living and modern conveniences at Passage in Vancouver, WA.\n",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 98683 - Passage",
      "seo_description": "Find spacious three bedroom apartments at Passage near Vancouver's 98683. Enjoy premium amenities for comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "apartments-near-clark-college-vancouver-wa",
      "search_query": "apartments near clark college vancouver wa",
      "category": "School",
      "h1_title": "Apartments Near Clark College, Vancouver WA",
      "h2_subtitle": "Discover convenient apartments near Clark College in Vancouver, WA. ",
      "page_copy": "Passage offers convenient apartment living near Clark College in Vancouver, WA. Located minutes from the college, our community offers easy access to Clark College, plus nearby shopping, dining, transportation, and other Vancouver destinations.\n\nPassage features a variety of modern apartment and community amenities, including a fitness center, large closets, in-unit washers and dryers, garage parking, and well-appointed kitchens with refrigerators. Choose Passage and discover comfortable apartment living, convenient amenities, and a location near Clark College in Vancouver, WA. \n",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Apartments Near Clark College, Vancouver WA",
      "seo_description": "Find convenient living at Passage, located near Clark College in Vancouver, WA. Enjoy modern amenities and proximity to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "apartments-near-vancouver-va-medical-center",
      "search_query": "apartments near vancouver va medical center clark county",
      "category": "Hospital",
      "h1_title": "Apartments Near Vancouver VA Medical Center",
      "h2_subtitle": "Explore ideal living options near Vancouver VA Medical Center in Clark County. Passage offers convenience and comfort.",
      "page_copy": "Discover comfortable apartment living at Passage, conveniently located near the Vancouver VA Medical Center in Clark County. Our community offers a blend of convenience and comfort, with easy access to the Medical Center, plus nearby shopping, dining, transportation, and other Vancouver destinations.\n\nPassage provides a range of apartment features and community amenities, including a fitness center, spacious closets, in-unit washers and dryers, modern kitchens with refrigerators, and garage parking. Choose Passage and enjoy thoughtfully designed apartment living and a convenient location near the Vancouver VA Medical Center in Vancouver, WA.\n",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Vancouver VA Medical Center - Passage",
      "seo_description": "Find comfortable living at Passage near Vancouver VA Medical Center in Clark County. Enjoy modern amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "apartments-close-to-vibra-specialty-hospital",
      "search_query": "apartments close to vibra specialty hospital portland",
      "category": "Hospital",
      "h1_title": "Apartments Close to Vibra Specialty Hospital",
      "h2_subtitle": "Explore living near Vibra Specialty Hospital in Portland. Passage offers an ideal setting close to essential healthcare services.",
      "page_copy": "Passage offers comfortable apartment living with convenient access to Vibra Specialty Hospital and destinations throughout the Vancouver and Portland area. Our community combines a convenient location with modern apartment features and amenities in a comfortable residential setting.\n\nResidents of Passage can enjoy a variety of amenities, including a fully equipped fitness center, ample closet space, and convenient in-unit washers and dryers. Each apartment also features a modern kitchen with a refrigerator, while garage parking adds everyday convenience. Discover Passage and enjoy modern apartment living with convenient access to Vibra Specialty Hospital and the surrounding area.\n",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Vibra Specialty Hospital - Passage",
      "seo_description": "Live near Vibra Specialty Hospital at Passage. Enjoy modern amenities and strategic location close to Portland healthcare services.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "apartments-near-rocky-butte-natural-area",
      "search_query": "apartments near rocky butte natural area vancouver wa",
      "category": "Park",
      "h1_title": "Apartments Near Rocky Butte Natural Area",
      "h2_subtitle": "Discover serene living near Rocky Butte Natural Area in Vancouver, WA. Passage offers comfort amidst nature.",
      "page_copy": "Nestled just a short drive from the tranquil Rocky Butte Natural Area, Passage offers an extraordinary lifestyle in Vancouver, WA. Our community provides an ideal retreat for nature lovers seeking apartments near this beautiful green space. Whether exploring the trails or enjoying a picnic, you'll appreciate having nature close at hand.\n\nAt Passage, residents are treated to a host of amenities designed for everyday convenience, including a fitness center, large closets, and the convenience of in-unit washers and dryers. Each apartment comes with a modern kitchen, featuring a refrigerator, and the added benefit of garage parking. Choose Passage for a harmonious blend of nature and urban living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rocky Butte Natural Area - Passage",
      "seo_description": "Live near Rocky Butte Natural Area at Passage in Vancouver, WA. Experience comfort and modern amenities amidst nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "apartments-close-to-fernhill-park-clark-county",
      "search_query": "apartments close to fernhill park clark county",
      "category": "Park",
      "h1_title": "Apartments Close to Fernhill Park",
      "h2_subtitle": "Discover comfortable living near Fernhill Park in Clark County. Passage offers convenience and modern amenities.",
      "page_copy": "Located conveniently close to Fernhill Park, Passage presents a unique residential opportunity in Clark County. Ideal for those who love the outdoors, our community offers convenient access to the green spaces and recreational facilities of Fernhill Park.\n\nPassage features a variety of amenities tailored to enhance your quality of life, including a modern fitness center, spacious closets, and in-unit washers and dryers. Enjoy meals in a contemporary kitchen equipped with a refrigerator, and take advantage of private garage parking. Choose Passage for a harmonious blend of convenient access to outdoor recreation and modern living conveniences.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Fernhill Park - Passage",
      "seo_description": "Find modern living near Fernhill Park at Passage in Clark County. Enjoy proximity to nature with all the comforts and amenities you need.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "apartments-by-wintler-community-park-98683",
      "search_query": "apartments by wintler community park 98683",
      "category": "Park",
      "h1_title": "Apartments by Wintler Community Park",
      "h2_subtitle": "Experience the ideal blend of nature and city life near Wintler Community Park. Passage offers premier living in the 98683 area.",
      "page_copy": "Situated in the scenic 98683 area, Passage offers an exceptional living experience near Wintler Community Park. This prime location is perfect for those who love spending time in nature, providing easy access to the park's beautiful trails and recreational areas. Whether it's a weekend picnic or a daily jog, you'll enjoy having such a serene escape just moments from home.\n\nPassage's amenities enhance your lifestyle with features like a state-of-the-art fitness center, large closets for ample storage, and the convenience of in-unit washers and dryers. All apartments include a fully equipped kitchen with a refrigerator, and residents also have access to garage parking. Choose Passage for unparalleled access to both the vibrancy of city life and the tranquility of nearby parks.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Wintler Community Park - Passage",
      "seo_description": "Live near Wintler Community Park at Passage in the 98683 area. Enjoy outdoor beauty and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "apartments-near-portland-international-airport",
      "search_query": "apartments near portland international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Portland International Airport",
      "h2_subtitle": "Discover convenience near Portland International Airport with Passage. Enjoy modern living just a short drive from the airport.",
      "page_copy": "Passage offers a unique living experience just a short drive from Portland International Airport, making it the ideal choice for frequent travelers and aviation enthusiasts. With its convenient location, residents can enjoy swift and easy commutes, whether for business or leisure trips.\n\nOur community features an array of exceptional amenities, including a well-equipped fitness center, ample storage through large closets, and the luxury of in-unit washers and dryers. Each apartment at Passage is designed with your needs in mind, featuring a modern kitchen complete with a refrigerator and secure garage parking. Choose Passage for a lifestyle where travel convenience meets modern comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Portland International Airport - Passage",
      "seo_description": "Find convenience at Passage, near Portland International Airport. Enjoy modern amenities and a prime location perfect for travelers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "apartments-close-to-portland-international-airport-station",
      "search_query": "apartments close to portland international airport station",
      "category": "Transit",
      "h1_title": "Apartments Near Portland Airport Station",
      "h2_subtitle": "Enjoy unbeatable accessibility near Portland International Airport Station with Passage. Experience modern living close to transit and travel options.",
      "page_copy": "Passage presents an unbeatable location near the Portland International Airport Station, offering convenient transportation access and modern comfort. This proximity means you can enjoy seamless travel connections, whether you're commuting into the city or flying out for a getaway.\n\nChoose Passage for comprehensive amenities designed to complement your lifestyle. Residents can take advantage of our fully-equipped fitness center, spacious closets, and the convenience of in-unit washers and dryers. Each apartment boasts a fully functional kitchen and garage parking. Embrace a lifestyle of convenience and contemporary living with Passage, ideally located near key transport facilities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Portland Airport Station - Passage",
      "seo_description": "Experience modern living near Portland International Airport Station at Passage. Enjoy convenience and contemporary amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "apartments-near-ne-82nd-ave-vancouver-wa",
      "search_query": "apartments near ne 82nd ave vancouver wa",
      "category": "Transit",
      "h1_title": "Apartments Near NE 82nd Ave, Vancouver, WA",
      "h2_subtitle": "Discover modern living just minutes from NE 82nd Ave. Passage in Vancouver, WA offers comfort and convenience in a prime location.",
      "page_copy": "Located in the vibrant city of Vancouver, WA, Passage is just a short drive from the bustling NE 82nd Ave. This convenient location places you near a variety of shopping, dining, and entertainment options, ensuring that whatever you need is never far from home.\n\nPassage provides an array of amenities designed to enhance your lifestyle. Enjoy a workout at our state-of-the-art fitness center or organize your items in the spacious closets available in each apartment. We offer the practicality of in-unit washers and dryers, as well as garage parking. With a fully equipped kitchen featuring a refrigerator, our community is perfect for those seeking a harmonious blend of convenience and modern living near NE 82nd Ave.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near NE 82nd Ave - Vancouver, WA - Passage",
      "seo_description": "Find your new home at Passage, near NE 82nd Ave in Vancouver, WA. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166807",
      "source": "custom",
      "page_item_url": "vancouver-wa-apartments-near-cascades-transit",
      "search_query": "vancouver wa apartments near cascades transit",
      "category": "Transit",
      "h1_title": "Vancouver WA Apartments Near Cascades Transit",
      "h2_subtitle": "Explore the ease of living near Cascades Transit at Passage, Vancouver, WA. Enjoy efficient travel and modern amenities right at your doorstep.",
      "page_copy": "Discover the perfect balance of convenience and comfort at Passage, located near Cascades Transit in Vancouver, WA. Living here ensures you're well-connected with easy access to public transit options, making commutes and travel as smooth as possible.\n\nPassage offers a comprehensive living experience with amenities tailored for modern needs. Stay fit in our advanced fitness center or enjoy the convenience of large closets for all your storage needs. Each apartment is equipped with a washer and dryer, ensuring laundry is never a hassle, and a refrigerator for all your culinary adventures. Garage parking adds to the ease of life at Passage, near Cascades Transit, where urban convenience meets homey comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Vancouver WA Apartments Near Cascades Transit - Passage",
      "seo_description": "Live near Cascades Transit in Vancouver, WA at Passage. Enjoy modern amenities and ease of travel with our prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "lindseye@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6014"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10714993765"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-K9XP8FVZ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Pathfinder 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Pathfinder Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "180PSG"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('ogkTrfNFSIHUAluZNM')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "41611142705"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/x1p8j5zrvd6"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "22009716"
    },
    {
      "ID": "custom_website_tracking_email",
      "type": "STRING",
      "value": "amcllc_passage_web_propertywebsite@leads.anyonehome.com"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Passage/scheduletourwidget/MRZhi8VTAK1SbSwJqN/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InBWT2E5UGJCWW5LTytOV0FrOUh0THc9PSIsInZhbHVlIjoiU21xbnZ2Ry9NdmZDdmJWQlFLT2I4QT09IiwibWFjIjoiZGVlZmFmYmFkYjYyZGI2ZjhjNDkyNmFlZmU4ZTc2M2VjM2ZkZGQ3ZDhjYmVhODcwYTNiZjY1ZGY5YzNiYmNmMyJ9"
    }
  ],
  "custom_csm": "lindseye@repli360.com",
  "custom_qb_id": "6014",
  "custom_repli_id": "10714993765",
  "custom_google_gtm_id": "GTM-K9XP8FVZ",
  "custom_rollout_phase": "Pathfinder 2",
  "custom_vibesites_theme": "Pathfinder Preferred",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_aim_property_code": "180PSG",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('ogkTrfNFSIHUAluZNM')</script>",
  "custom_hubspot_company_id": "41611142705",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/x1p8j5zrvd6",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "22009716",
  "custom_website_tracking_email": "amcllc_passage_web_propertywebsite@leads.anyonehome.com",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Passage/scheduletourwidget/MRZhi8VTAK1SbSwJqN/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InBWT2E5UGJCWW5LTytOV0FrOUh0THc9PSIsInZhbHVlIjoiU21xbnZ2Ry9NdmZDdmJWQlFLT2I4QT09IiwibWFjIjoiZGVlZmFmYmFkYjYyZGI2ZjhjNDkyNmFlZmU4ZTc2M2VjM2ZkZGQ3ZDhjYmVhODcwYTNiZjY1ZGY5YzNiYmNmMyJ9",
  "custom_audioeye_site_id": "fbf3d0ce-b48a-4e70-b7d1-2e1a137dd9df",
  "custom_audioeye_site_hash": "ec860c2135d896780f02e7d0b29914d9"
};

export const generatedAt = '2026-10-22T16:38:38.192Z';
